import { ChangeDetectorRef, Component, ElementRef, inject, ViewChild, WritableSignal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonComponent } from "@components/shared/button/button.component";
import { APP_PREVIEW } from '@configuration/preview';
import { ButtonColors } from '@models/enums/components/Button/ButtonColor.enum';
import { Preview } from '@models/interfaces/core/Preview.interface';
import { CredentialsService } from '@services/credentials.service';
import { PortalService } from '@services/portal.service';
import anime from 'animejs';
import { tap } from 'rxjs';

@Component({
    selector: 'app-site-login',
    imports: [
        ButtonComponent,
        FormsModule
    ],
    templateUrl: './site-login.component.html',
    styleUrl: './site-login.component.css'
})
export class SiteLoginComponent {

  @ViewChild('siteLoginContainer', {read: ElementRef}) 
  public readonly siteLoginContainer!: ElementRef<HTMLDivElement>;

  // SERVICES
  private readonly portal:      PortalService             = inject(PortalService);
  private readonly credentials: CredentialsService        = inject(CredentialsService);
  private readonly preview:     WritableSignal<Preview>   = inject(APP_PREVIEW);
  private readonly cdr:         ChangeDetectorRef         = inject(ChangeDetectorRef);
  
  
  // BUTTON
  public readonly buttonColor:  ButtonColors              = ButtonColors.Accent;


  // STATE
  public email:    string   = '';
  public password: string   = '';
  public loading:  boolean  = false;
  public error:    boolean  = false;
  

  // METHODS
  public login(): void {
    
    const data: {accountName: string, password: string, previewId: number} = {
      accountName: this.email,
      password:    this.password,
      previewId:   this.preview().id
    };

    this.credentials.loginPreview(data).pipe(
      tap((): void => {
        this.loading = true;
        this.cdr.markForCheck();
      })
    ).subscribe({
      next: (): void => { window.setTimeout((): void => this.hideForm(), 200) },
      error:(): void => this.resetForm(true),
    })

  }

  private hideForm(): void {

    anime({
      targets: this.siteLoginContainer.nativeElement,
      opacity: [1, 0],
      easing: 'easeInOutQuad',
      duration: 500,
      complete: ():void => this.portal.resetPortal()
    })


  }

  private resetForm(error: boolean = false): void {
    this.email    = '';
    this.password = '';
    this.error    = error;
    this.loading  = false;
    this.cdr.markForCheck();
  }

}
